import React, { useState, useContext } from 'react';
import { useHistory } from 'react-router-dom';

import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Grid from '@mui/material/Grid';

import DataTable from '../../../sharedModules/dataTable';

import PageHeader from '../../../sharedModules/layout/PageHeader';
import PlumbingIcon from '@mui/icons-material/Plumbing';
import BackflowJobsFilter from '../components/BackflowJobsFilter';
import LoadingWrapper from '../../../sharedModules/layout/LoadingWrapper';
import ErrorMessage from '../../../sharedModules/layout/ErrorMessage';

import { AuthenticationContext } from '../../../homeModules/auth/contexts/AuthenticationContext';

import { backflowJobGroupsColumns } from '../constants/backflowListColumns';
import { useBackflowApprovalQueue, defaultBackflowApprovalQueueFilters } from '../hooks/useBackflowJobGroups';

const BackflowTestApprovalsQueuePage: React.FunctionComponent = () => {
  const history = useHistory();

  const { user } = useContext(AuthenticationContext);

  const [filterValues, setFilterValues] = useState<any>(defaultBackflowApprovalQueueFilters);

  const { data, isLoading, isError } = useBackflowApprovalQueue(filterValues, { enabled: !!user });
  const backflowJobGroups = data?.data?.result ?? [];

  return (
    <Grid container>
      <Grid item xs={12}>
        <LoadingWrapper isLoading={isLoading} message="Loading Backflow Jobs">
          <Grid container>
            <Grid item xs={12}>
              <ErrorMessage message={isError ? 'Failed to load backflow jobs. Please try again.' : null} />
            </Grid>
            <Grid item xs={12}>
              <PageHeader mainTitle="Backflow Approval Queue" titleIcon={<PlumbingIcon />} />
            </Grid>
            <Grid item xs={12} style={{ marginTop: 20, marginBottom: 20 }}>
              <BackflowJobsFilter
                includeStatus={false}
                filterValues={filterValues}
                setFilterValues={setFilterValues}
                onFilter={(filterVals) => setFilterValues(filterVals)}
              />
            </Grid>

            <Grid item xs={12}>
              <Card>
                <CardContent>
                  <DataTable
                    title=""
                    columns={backflowJobGroupsColumns(undefined, true, 'submitted')}
                    data={backflowJobGroups}
                    onRowClicked={(row: any) => history.push(`/backflow_tests/backflow_job_groups/${row.id}/approve`)}
                    dense
                    highlightOnHover
                    pointerOnHover
                    pagination
                    paginationPerPage={25}
                    paginationRowsPerPageOptions={[25, 50, 100]}
                    noHeader
                  />
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        </LoadingWrapper>
      </Grid>
    </Grid>
  );
};

export default BackflowTestApprovalsQueuePage;
